<div class="bg-white rounded-tl-lg rounded-tr-lg text-dark-grey overflow-hidden">
  <app-modal-header
    title="Passwort ändern"
    iconPath="assets/icons/key.svg"
  />

  <div class="p-6">
    <form class="mb-15">
      <app-password-input
        label="Altes Password"
        [control]="form.controls.oldPassword"
      />

      <app-password-input
        label="Neues Passwort"
        [control]="form.controls.newPassword"
      />

      <ul class="list-disc pl-8 mb-4">
        <li>Mindestens ein Großbuchstabe</li>
        <li>Mindestens ein Kleinbuchstabe</li>
        <li>Mindestens eine Zahl</li>
        <li>Mindestens 5 Zeichen</li>
      </ul>

      <app-password-input
        label="Neues Passwort wiederholen"
        [control]="form.controls.confirmNewPassword"
      />
    </form>

    <app-button
      text="Speichern"
      [isLoading]="isLoading()"
      [disabled]="form.invalid || !form.dirty"
      [fullWidth]="true"
      (clicked)="updatePassword()"
    />
  </div>
</div>
